import { observer } from "mobx-react";
import React from "react";
import { L10n } from "@fidget/common/i18n";
import { intl } from "@fidget/common/i18n/TypedIntl";
import commonStyles from "../../../../containers/settings/settingsEditCommon.css";
import { withPermissionFallback } from "../../../HOC/withPermissionFallback/withPermissionFallback";
import { withPreloading } from "../../../HOC/withPreloading/withPreloading";
import { SettingsListFilterProvider } from "../../settingsForms/filters/useListFilter/useListFilter";
import { SubtitleDescription } from "../../subtitleDescription";
import { GroupEditScreen } from "./components/groupEditScreen/groupEditScreen";
import { TagGroupsSettingsList } from "./tagGroupsSettingsList";
import { ExistingTagGroupFormType } from "./types";
import { TagGroupSettingsProvider, useTagGroupsSettings } from "./useTagGroupsSettings";
import { staticConfig } from "@fidget/common/config/static-config";
import { AppPermission } from "@closerplatform/spinner-openapi";

const TagGroupsSettingsComponent = observer(() => {
  const { currentlyEditedItem, discardEditedItem } = useTagGroupsSettings();

  const renderList = () => (
    <>
      <div className={commonStyles.title}>
        <L10n id="settings.admin.tagGroups" />
      </div>
      <div className={commonStyles.section}>
        <SubtitleDescription
          description={intl.formatMessage("settings.tagGroups.list.description", {
            limit: staticConfig.tagGroupsMaxNumber
          })}
        />
        <div className={commonStyles.content}>
          <SettingsListFilterProvider<ExistingTagGroupFormType>>
            <TagGroupsSettingsList />
          </SettingsListFilterProvider>
        </div>
      </div>
    </>
  );

  const renderEditGroupScreen = (item: ExistingTagGroupFormType) => (
    <GroupEditScreen group={item} onGoBack={discardEditedItem} />
  );

  return currentlyEditedItem ? renderEditGroupScreen(currentlyEditedItem) : renderList();
});

const WithProvider = () => (
  <TagGroupSettingsProvider>
    <TagGroupsSettingsComponent />
  </TagGroupSettingsProvider>
);

export const TagGroupsSettings = withPermissionFallback<{}>(
  AppPermission.SettingsTags,
  withPreloading(WithProvider)
);
